import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { AutocompleteResult } from '../../../models/autocomplete-result';

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss']
})
export class FormSelectComponent implements OnInit, OnChanges {
  @Input() customLabel: boolean = false;

  @Input() disabled: boolean = false;

  @Input() selectName: string = `v6-${Math.random().toString(36).slice(2)}`;

  @Input() label: string

  @Input() helpText: string;

  @Input() selectOptions: Array<AutocompleteResult> = [];

  @Input() model: string;

  @Output() modelChange: EventEmitter<string> = new EventEmitter<string>();

  selectedValue: string;

  constructor() { }

  ngOnInit(): void {
    this.assignFormSelectValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.model){
      this.assignFormSelectValue();
    }
  }

  assignFormSelectValue() {
    this.selectedValue = this.model;
  }

  updateFormSelectValue() {
    this.modelChange.emit(this.selectedValue);
  }
}
